import React, { useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError, Field } from 'redux-form'
import { Breadcrumb, Button, Modal } from 'semantic-ui-react'
import { pascalCase } from 'change-case'
import { MainBodyContent } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import GeneralInformation from '../Form/GeneralInformation'
import ReferenceBG from '../Form/ReferenceBG'
import BankGuaranteeInformation from '../Form/BankGuaranteeInformation'
import ProjectManager from '../../../Form/ProjectManager'
import VendorContact from '../Form/VendorContact'
import Attachment from '../Form/Attachment'
import CommentHistory from '../../../Form/CommentHistory'
import { bgVendorReportPath } from 'routes'
import { DocumentTypeContent } from './styled'
import { getBankGuaranteeDetail, patchDataBankGuarantee, cancelBankGuarantee } from 'ducks/bankGuarantee'
import { StatusTag } from '../../../styled'
import { validateOriginalForm } from '../../../helper'

const BankGuaranteeDetail = (props) => {
  const { valueForm, change, username, bgDetail } = props
  const [editMode, setEditMode] = useState(false)
  const [mainFormClickSave, setMainFormClickSave] = useState(false)
  const [showConfirmUpdate, setShowConfirmUpdate] = useState(false)
  const [showConfirmCancel, setShowConfirmCancel] = useState(false)
  const [comment, setComment] = useState('')

  React.useEffect(() => {
    const id = props.match.params.id || ''
    props.getBankGuaranteeDetail(id)
  }, [])

  const onSubmitUpdateForm = (values) => {
    if (mainFormClickSave) {
      var errors = validateOriginalForm(values)

      if (Object.keys(errors).length) {
        scrollToFirstValidateFailElement(errors)
        setMainFormClickSave(false)
        throw new SubmissionError(errors)
      } else {
        setMainFormClickSave(false)
        setShowConfirmUpdate(true)
      }
    }
  }
  
  return (
    <MainBodyContent 
      headerTitle={
        <React.Fragment>
          {`Bank Guarantee - ${valueForm.documentNumber ?? 'Detail'}`}
          <StatusTag status={valueForm.status} style={{ marginLeft: '10px' }}>{valueForm.statusName}</StatusTag>
        </React.Fragment>
      }
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'BG', content: 'Bank Guarantee', link: true, onClick: () => props.history.push(bgVendorReportPath) },
              { key: 'BGDetail', content: editMode ? 'Edit Mode' : 'Detail', active: true }
            ]
          }
        />
      }
      accessoriesHeader= {
        valueForm.createdBy === username && (valueForm.status === 1 || valueForm.status === 18) ?
          <div className='cardHeaderActions'>
            {
              editMode ? 
              <Button
                type='button'
                content='Close'
                icon='times'
                color='red'
                labelPosition='right'
                style={{ marginRight: '5px' }}
                onClick={() => {
                  setEditMode(false)
                  change('title', bgDetail.title)
                  change('remark', bgDetail.remark)
                  change('typeOfBond', bgDetail.typeOfBond)
                  change('otherTypeOfBond', bgDetail.otherTypeOfBond)
                  change('job', bgDetail.job)
                  change('location', bgDetail.location)
                  change('depositAtBank', bgDetail.depositAtBank)
                  change('depositDate', bgDetail.depositDate)
                  change('depositor', bgDetail.depositor)
                  change('depositRemark', bgDetail.depositRemark)
                  change('projectManagerUser', bgDetail.projectManagerUser)
                  change('vendorContacts', bgDetail.vendorContacts)
                }}
              /> :
              <Button
                type='button'
                content='Edit'
                icon='pencil'
                color='green'
                labelPosition='right'
                style={{ marginRight: '5px' }}
                onClick={() => setEditMode(true)}
              />
            }
          </div> : null
      }
      headerStyle={{
        paddingLeft: '5px',
        paddingRight: '0px'
      }}
    >
      <form onSubmit={props.handleSubmit((values) => onSubmitUpdateForm(values))}>
        <DocumentTypeContent>Document Type : {pascalCase(valueForm.createType)}</DocumentTypeContent>
        <GeneralInformation valueForm={valueForm} change={change} isDisplay editMode={editMode} />
        <ReferenceBG valueForm={valueForm} change={change} isDisplay />
        <BankGuaranteeInformation valueForm={valueForm} change={change} isDisplay editMode={editMode} />
        <ProjectManager valueForm={valueForm} change={change} isDisplay editMode={editMode} />
        <VendorContact valueForm={valueForm} change={change} isDisplay editMode={editMode} formName='formBankGuarantee' />
        {
          editMode ?
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
            <Button
              type='button'
              content='Cancel Document'
              icon='times'
              color='red'
              labelPosition='left'
              style={{ marginRight: '5px' }}
              onClick={() => {
                setShowConfirmCancel(true)
              }}
            />
            <Button
              type='submit'
              content='Update'
              icon='save'
              color='green'
              labelPosition='right'
              onClick={() => {
                setMainFormClickSave(true)
              }}
            />
          </div> : null
        }
        <Attachment valueForm={valueForm} change={change} isDisplay />
        <CommentHistory comments={valueForm.comments} attachment={valueForm.attachment03} />
      </form>
      <Modal open={showConfirmCancel}>
        <Modal.Header>Are Your Sure ?</Modal.Header>
        <Modal.Content>
          <form>
            <Field name='comment' label='Comment' require editable type={type.textArea} specialOnChange={(data) => { setComment(data) }} component={FieldInput} />
          </form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            type='button'
            content='Cancel'
            color='red'
            disabled={comment.length === 0}
            style={{ marginRight: '5px' }}
            onClick={() => {
              props.cancelBankGuarantee(valueForm.id, comment, props.history)
              setShowConfirmCancel(false)
            }}
          />
          <Button
            type='button'
            content='Close'
            color='gray'
            onClick={() => {
              setComment('')
              setShowConfirmCancel(false)
            }}
          />
        </Modal.Actions>
      </Modal>
      <Modal open={showConfirmUpdate}>
        <Modal.Header>Are Your Sure ?</Modal.Header>
        <Modal.Content>
          <form>
            <Field name='comment' label='Comment' editable type={type.textArea} specialOnChange={(data) => { setComment(data) }} component={FieldInput} />
          </form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            type='button'
            content='Update'
            color='green'
            style={{ marginRight: '5px' }}
            onClick={() => {
              props.patchDataBankGuarantee({...valueForm, comment: comment}, () => {
                setEditMode(false)
                setMainFormClickSave(false)
                setShowConfirmUpdate(false)
                window.location.reload()
              })
            }}
          />
          <Button
            type='button'
            content='Close'
            color='gray'
            onClick={() => {
              setComment('')
              setShowConfirmUpdate(false)
            }}
          />
        </Modal.Actions>
      </Modal>
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const username = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  return ({
    username,
    valueForm: getFormValues('formBankGuarantee')(state) || {},
    initialValues: {
      ...state.bg.bankGuarantee.data
    },
    bgDetail: state.bg.bankGuarantee.data,
  })
}

const mapDispatchToProps = {
  getBankGuaranteeDetail,
  patchDataBankGuarantee,
  cancelBankGuarantee
}

const validate = (values) => {
  let errors = {}

  return errors
}

const BankGuaranteeDetailForm = reduxForm({
  form: 'formBankGuarantee',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(BankGuaranteeDetail)

export default connect(mapStateToProps, mapDispatchToProps)(BankGuaranteeDetailForm)
